/** @jsx jsx */
import React, {
	useRef,
	useState,
	useEffect,
	useContext,
	useCallback,
} from 'react';
import { Flex, Box, Heading, Text, jsx, Button, Select } from 'theme-ui';
import { graphql } from 'gatsby';
//import Img from 'gatsby-image';
import { GatsbyImage } from "gatsby-plugin-image"
import { IoIosAdd, IoIosRemove } from 'react-icons/io';
import SEO from '../components/seo';
import PrimaryLayout from '../components/layout/primary/primary';
//import SecondaryLayout from '../components/layout/secondary/secondary';
import SocialShare from '../components/social-share/social-share';
import CallusBanner from '../components/call-us-banner/call-us-banner';
import { CartContext } from '../provider/cart-provider';
import { LocalCartContext } from '../provider/local-cart-provider';
import useOnClickOutside from '../hooks/useOutsideClick';
import styles from '../components/product-single.style';
import ProductGrid from '../components/product-grid/product-grid';
import isEqual from 'lodash.isequal';
import ReactPlayer from 'react-player/lazy'
import { getSessionState } from '../helper/session-storage';
import Carousel from '../components/carousel/carousel';


const ProductPage: React.FC<any> = ({
	data: { shopifyProduct, shopifyCollection, prismic=null },
	location: { href },
}) => {
	let product = shopifyProduct;
	product.listView = false;

	const categoryProducts = shopifyCollection?.products || [];
	const {
    	options,		
		title,
		price,
		variants,
		variants: [initialVariant],
		thumbnail,
		prevPrice,
		listView = false,
		productType,
		metafields,
	} = product;

	const hasVariants = variants.length > 1;
	
	const {
		store: { client },
	} = useContext(CartContext);

	const { products, add, update, shopConfig } = useContext(LocalCartContext);
	const counterRef = useRef(null!);
	const [showCounter, setShowCounter] = useState(false);
	useOnClickOutside(counterRef, () => setShowCounter(false));

	const [variant, setVariant] = useState({ ...initialVariant });
	const productVariant = client.product.helpers.variantForOptions(product, variant) || variant;
	const productIndex = products.findIndex(
		(item) => item.variantId === productVariant.shopifyId
	);

	const cartProduct = productIndex > -1 ? products[productIndex] : false;
	const cartProductQuantity = cartProduct ? cartProduct.quantity : 0;
	const [quantity, setQuantity] = useState(0);
	
	const [productPrice, setProductPrice] = useState({ price, prevPrice });
	
	const [available, setAvailable] = useState(productVariant.availableForSale);
	const checkAvailability = useCallback(
		(productId) => {
			client.product.fetch(productId).then((fetchedProduct) => {
				// this checks the currently selected variant for availability
				const result = fetchedProduct.variants.filter(
					(variant) => variant.id === productVariant.shopifyId
				);
				if (result && result.length > 0) {
					setAvailable(result[0]?.available);
					setProductPrice({price: getPrice(result[0].weight, shopConfig, true, result[0].price), prevPrice: getPrice(result[0].weight, shopConfig, false, result[0].compareAtPrice)});
					productVariant.price = result[0].price
					//productVariant.priceV2 = result[0].priceV2
					//productVariant.compareAtPriceV2 = result[0].compareAtPriceV2
					productVariant.compareAtPrice = result[0].compareAtPrice
					setVariant(productVariant)				
				}
			});
		},
		[client.product, productVariant.shopifyId, variants]
	);

	useEffect(() => {
		setQuantity(cartProductQuantity);
	}, [cartProductQuantity]);

	useEffect(() => {
		checkAvailability(product.shopifyId);
	}, [productVariant, checkAvailability, product.shopifyId]);

	const handleQuantityChange = (quantity: number) => {
		update(productVariant.shopifyId, quantity);
		if (quantity < 1) {
			setShowCounter(false);
		}
	};

  const handleOptionChange = (index, event) => {
    const value = event.target.value

    if (value === "") {
      return
    }

    const currentOptions = [...variant.selectedOptions]

    currentOptions[index] = {
      ...currentOptions[index],
      value,
    }

    const selectedVariant = variants.find((variant) => {
      return isEqual(currentOptions, variant.selectedOptions)
    })

    setVariant({ ...selectedVariant })
  }

	const handleAddToCart = () => {
		if (!available) {
			return false;
		}
		setShowCounter(true);
		if (quantity < 1) {
			const item = {
				title,
				thumbnail: product?.images[0]?.gatsbyImageData,
				quantity: 1,
				price: productVariant.price,
				currency: 'INR',
				variantId: productVariant.shopifyId,
			};
			add(item);
		}
	};

	const addClass = ['productCard'];
	if (quantity > 0 && showCounter) {
		addClass.push('active');
	}
	if (!available) {
		addClass.push('disabled');
	}

	const callUsBannerData = prismic?.allChat2orderhomes?.edges[0]?.node;
	//const callUsBannerData = null;
	/*const getPrice = (price: any) =>
		Intl.NumberFormat(undefined, {
			currency: price && price.currencyCode ? price.currencyCode : 'INR',
			minimumFractionDigits: 2,
			style: 'currency',
		//}).format(parseFloat(price && price.amount ? price.amount : 0));
		}).format(parseFloat(price && price.amount ? price.amount : price));*/
	
	const getPrice = (weight: any, shopConfig: any, applyMcDisc = false, price = 0) => {
		console.log(`shopConfig: ${JSON.stringify(shopConfig)}`)
		shopConfig = getSessionState('shopConfig');
		let gold, silver;
		let makingChargePc = 0;
		let makingChargeDisc = 0;				
		if(metafields && metafields.length > 0) {
			metafields.map( field => {
				if(field.key === 'making_charge_pc') {
					makingChargePc = field.value
				}
			})
		}
		if(shopConfig.config) {
			shopConfig.config.map( field => {
				switch (field.key) {
					case 'gold':
						gold = field.value;
						break;
					case 'silver':
						silver = field.value;
						break;
					case 'mc_discount':
						makingChargeDisc = field.value;
						break;						
					default:
						break;
				}
			})
			/*if(parseFloat(makingChargePc) > parseFloat(makingChargeDisc) && applyMcDisc) {
				makingChargePc = makingChargePc - makingChargeDisc
			}*/	
			if( applyMcDisc ) {
				makingChargePc = parseFloat(makingChargePc) * ( 1 - parseFloat(makingChargeDisc)/100 )
			}		
			let rate = productType === 'gold_jewellery' ? gold : productType === 'silver_jewellery' ? silver : 0;
			//let rate = 0
			//console.log(`product type: ${productType}`)
			/*if(productType === 'gold_jewellery') {
				rate = gold
			}*/
			if(rate !== 0) {
				return Intl.NumberFormat('en-IN', {
					currency: 'INR',
					minimumFractionDigits: 2,
					style: 'currency',
				}).format(parseFloat( weight * rate + weight * rate * makingChargePc/100 + (weight * rate + weight * rate * makingChargePc/100) * 0.03));					
			}
			else {
				return Intl.NumberFormat(undefined, {
					currency: 'INR',
					minimumFractionDigits: 2,
					style: 'currency',
				}).format(parseFloat(price && price.amount ? price.amount : 0.00));						
			}
		}
		return Intl.NumberFormat(undefined, {
			currency: 'INR',
			minimumFractionDigits: 2,
			style: 'currency',
		}).format(parseFloat(0));			
			
	}
	
	const handleSendToWa = () => {		
		if (typeof window !== "undefined") {
			let msg = encodeURIComponent(`I'm interested in - ${title} - ${window.location.href}`)
			typeof window !== "undefined" && window.gtag("event", "click", { productPath: window.location.href })			
			window.open(`https://wa.me/919433828242?text=${msg}`)		
		}
	};	

	const responsive = {
		ipad: {
			breakpoint: { max: 100000, min: 651 },
			items: 1,
			partialVisibilityGutter: 40,
		},
		mobile: {
			breakpoint: { max: 650, min: 0 },
			items: 1,
		},
	};
	const isBrowser = typeof window !== "undefined";
	const [width, setWidth] = useState<number>(isBrowser ? window.innerWidth : 0);
	
	function handleWindowSizeChange() {
		setWidth(isBrowser ? window.innerWidth : 0);
	}
	useEffect(() => {
		if (isBrowser) {
			window.addEventListener('resize', handleWindowSizeChange);
			return () => {
				window.removeEventListener('resize', handleWindowSizeChange);
			}
		}
	}, []);
	
	const isMobile = width <= 768;
	
	return (
		<PrimaryLayout
			bgColor="#ffffff"
			fluid={true}
			homeLink="/"
			pathPrefix="/collection"
			showNoticeBar={false}
		>
			<Box sx={styles.wrapper}>
				<SEO title={product.title} product={true} productDetails={{productId: product.shopifyId.includes("gid://shopify") ? product.shopifyId.split('/')[4] : atob(product.shopifyId).split('/')[4], name: product.title, description: product?.description, handle: product.handle, image: product?.images[0]?.originalSrc, price: product?.variants[0]?.price, availableForSale: available}} />
				<Flex sx={styles.product}>
					<Box
						className={product?.images.length > 1 ? 'has-items' : ''}
						sx={styles.image}
					>
					<Carousel ssr={true} responsive={responsive} gutter="1px" partialVisible={true}>					
						{product?.images.map((item: any) => (
							<GatsbyImage image={item?.gatsbyImageData} alt={product?.title} key={item?.id}/>
						))}
						{/*product?.metafields.map((field: any) => (
							
							(field.key === 'video' && <ReactPlayer volume={0} height='100%' loop={true} playing={true} playsinline={true} muted={true} style={{ margin: '5px',
							borderRadius: '4px',
							border: `1px solid #f0f0f0`,}}url={field.value} />)
						))*/}
						{product?.metafields.map((field: any) => (
							
							(field.key === 'video' && 
							<ReactPlayer 
								height={isMobile ? "auto" : undefined} 
								width={isMobile ? "auto" : undefined} 
								volume={0} 
								loop={true} 
								playing={true} 
								playsinline={true} 
								muted={true} 
								style={{ position: 'absolute',
										 top: '0px', 
										 left:'0px', 
										 objectFit: 'cover', 
										 top: '50%', 
										 left: '50%', 
										 transform: 'translate(-50%, -50%)'}}
								url={field.value} />)
						))}						
					</Carousel>							
					</Box>
						
					<Box sx={styles.content}>
						<Box sx={styles.header}>
							<Heading as="h1">{product.title}</Heading>
						  {hasVariants &&
							options.map(({ id, name, values }, index) => (							
							<Select onChange={(event) => handleOptionChange(index, event)}
							  arrow={
								<Box
								  as="svg"
								  xmlns="http://www.w3.org/2000/svg"
								  width="48"
								  height="48"
								  viewBox="0 0 24 24"
								  fill="primary"
								  sx={{
									ml: -28,
									alignSelf: 'center',
									pointerEvents: 'none',
								  }}>
								  <path d="M7.41 7.84l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
								</Box>
							  }							
							>
							  <option value="">{`Select ${name}`}</option>
							  {values.map((value) => (
								<option value={value} key={`${name}-${value}`}>
								  {value}
								</option>
							  ))}
							</Select>
							))}	
							<Flex sx={styles.weightArea}>
								<Text sx={styles.price}>
									{`Weight: ${variant.weight}g`}
								</Text>									
							</Flex>														
							<Flex sx={styles.cartArea}>
								<Text sx={styles.price}>
									{productPrice.price}&nbsp;<span sx={styles.prevPrice}>{productPrice.prevPrice}</span>
								</Text>							
								{ /*<Box
									className={quantity > 0 && showCounter ? 'isActive' : ''}
									sx={styles.cart}
								>
									{!quantity && (
									<Button variant="green" onClick={() => handleSendToWa()}>
										<svg fill="#ffffff" height="18px" width="18px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 308 308" stroke="#12f202"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="XMLID_468_"> <path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156 c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687 c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887 c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153 c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348 c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802 c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922 c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0 c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458 C233.168,179.508,230.845,178.393,227.904,176.981z"></path> <path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716 c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396 c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188 l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677 c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867 C276.546,215.678,222.799,268.994,156.734,268.994z"></path> </g> </g></svg>
									</Button>
									)}
									{quantity ? (
										<Box ref={counterRef} sx={styles.cartCounter}>
											<Button
												title="Decrement"
												onClick={() => handleQuantityChange(quantity - 1)}
											>
												<IoIosRemove />
											</Button>
											<Box>{quantity}</Box>
											<Button
												title="Increment"
												onClick={() => handleQuantityChange(quantity + 1)}
											>
												<IoIosAdd />
											</Button>
										</Box>
									) : null}
								</Box> */}								
							</Flex>	
							<Flex sx={styles.buttonArea}>
								<Button variant="green" onClick={() => handleSendToWa()}>
									<svg fill="#ffffff" height="18px" width="18px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 308 308" stroke="#12f202"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="XMLID_468_"> <path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156 c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687 c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887 c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153 c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348 c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802 c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922 c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0 c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458 C233.168,179.508,230.845,178.393,227.904,176.981z"></path> <path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716 c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396 c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188 l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677 c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867 C276.546,215.678,222.799,268.994,156.734,268.994z"></path> </g> </g></svg>
								</Button>									
							</Flex>												
						</Box>
						<Text dangerouslySetInnerHTML={{__html: product?.descriptionHtml}}></Text>
						{product?.tags && (
							<Box sx={styles.tagArea}>
								<Text sx={styles.tagTitle}>Tag:</Text>
								<Box>
									{product?.tags.map((item: string) => (
										<Box key={item} as="span">
											{item}
										</Box>
									))}
								</Box>
							</Box>
						)}
						<SocialShare title={product?.title} url={href} />						
					</Box>
				</Flex>
				<ProductGrid
					id="relatedProducts"
					gridTitle="Related Products"
					products={categoryProducts}
					withLink={true}
					isCategoryProduct={true}
				/>
				<CallusBanner
					callUsBanner={null}
					callUsTitle={`Great festival discounts at amazon.in`}
					callUsButtonText=''
				/>					
			</Box>
		</PrimaryLayout>
	);
};

export const pageQuery = graphql`
	query($handle: String!) {
		shopifyProduct(handle: { eq: $handle }) {
			handle
			title
			description
			descriptionHtml
			createdAt
			shopifyId
			variants {
				id
				price
				compareAtPrice				
				shopifyId
				availableForSale
				selectedOptions {
				  name
				  value
				}
				weight				
			}
			options {
			  name
			  values
			  id
			}			
			images {
				id
				originalSrc
				gatsbyImageData(layout: CONSTRAINED)
			}
			metafields {
			  key			  
			  value
			}
			productType			
		}
		shopifyCollection(products: { elemMatch: { handle: { eq: $handle } } }) {
			image {
			  gatsbyImageData(layout: CONSTRAINED)
			  id
			  originalSrc
			}
			products {
				id
				title
				handle
				createdAt
				shopifyId
				variants {
					id
					price
					compareAtPrice				
					shopifyId
					availableForSale
					selectedOptions {
					  name
					  value
					}
					weight				
				}
				images {
				  gatsbyImageData(layout: CONSTRAINED)
				  id
				  originalSrc
				}
				metafields {
				  key			  
				  value
				}
				productType					
			}
		}				
	}
`;

export default ProductPage;
